import { useRef, useState } from "react";

// Components
import { TagName } from "components/TagName";
import NavButton from "components/HeaderNavigation/NavButton";
import { Card, CardContent, Box, Typography, Skeleton } from "@mui/material";
import SearchInput from "components/SearchInput";

// Hooks
import useAuth from "utils/hooks/useAuth";
import { FormattedMessage } from "react-intl";
import useChooseYourHub from "./useChooseYourHub";

// Styles
import useStyles from "./ChooseYourHub.styles";
import { getRoleName } from "./adapters/converters";

const ChooseYourHub = () => {
    const classes = useStyles();
    const { sessionData } = useAuth();
    const hubsListRef = useRef<HTMLDivElement | null>(null);
    const searchInputWrapperRef = useRef<HTMLDivElement | null>(null);

    const { userOrgs, updateSelectedOrg } = useChooseYourHub();
    const [filterValue, setFilterValue] = useState("");
    const filteredHubs = userOrgs.data.filter((hub) => hub.name.toLowerCase().includes(filterValue.toLowerCase()));
    const showHubSearch = userOrgs.data.length > 4;

    const handleHubSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilterValue(e.target.value);
    };

    return (
        <Box className={classes.mainWrapper}>
            <Card className={classes.cardContainer}>
                <CardContent className={classes.cardContent}>
                    <Typography className={classes.title}>
                        <FormattedMessage
                            id="chooseYourHub.welcome"
                            values={{ userName: sessionData?.authn.user.name }}
                        />
                    </Typography>
                    <Box mb={!showHubSearch ? 2 : 0}>
                        <Typography className={classes.subtitle}>
                            <FormattedMessage id="chooseYourHub.chooseYourHub" />
                        </Typography>
                        <Typography className={classes.intro} paragraph>
                            <FormattedMessage id="chooseYourHub.intro" />
                        </Typography>
                    </Box>

                    {showHubSearch && (
                        <Box ref={searchInputWrapperRef}>
                            <SearchInput
                                visualVariant="hub"
                                placeholder="Filter Hub"
                                onChange={handleHubSearch}
                                value={filterValue}
                            />
                        </Box>
                    )}

                    <Box ref={hubsListRef} className={classes.hubsList} sx={!showHubSearch ? { mt: 2 } : undefined}>
                        {filteredHubs.map((hub) => (
                            <Box key={hub.id} className={classes.hub}>
                                <Box>
                                    <TagName>{hub.name}</TagName>
                                    <Box sx={{ mt: 1 }}>
                                        <span>
                                            <FormattedMessage id="chooseYourHub.ldPermission" />:
                                        </span>{" "}
                                        {getRoleName(hub, "IS_LD")?.label} |{" "}
                                        <span>
                                            <FormattedMessage id="chooseYourHub.pacePermission" />:
                                        </span>{" "}
                                        {getRoleName(hub, "IS_PACE")?.label}
                                    </Box>
                                </Box>
                                <NavButton
                                    icon={null}
                                    showBackArrow={false}
                                    onClick={() => updateSelectedOrg(hub.id)}
                                    translationId="chooseYourHub.enter"
                                />
                            </Box>
                        ))}
                        {userOrgs.status === "fetching" &&
                            Array.from(Array(3)).map((_, i) => <Skeleton animation="wave" height={47} key={i} />)}
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
};

export default ChooseYourHub;
